__turbopack_context__.v({
  "className": "domainedisplay_14bbfb66-module__HD0tVW__className",
});
